import type { LucideIcon } from "lucide-react";
import type { ReactElement } from "react";

export type IconSize = 12 | 16 | 20 | 24 | 32;

export interface IconProps {
  readonly icon: LucideIcon;
  readonly size?: IconSize;
  readonly label?: string;
  readonly isFilled?: boolean;
}

export const Icon = ({ icon: Glyph, size = 20, label, isFilled = false }: IconProps): ReactElement => {
  const semantics = label === undefined ? { "aria-hidden": true } : { role: "img", "aria-label": label };
  return (
    <Glyph
      size={size}
      strokeWidth={1.5}
      nonScalingStroke
      focusable="false"
      fill={isFilled ? "currentColor" : "none"}
      {...semantics}
    />
  );
};
